import { render, staticRenderFns } from "./sysSucOrderList.vue?vue&type=template&id=5e708228&scoped=true&"
import script from "./sysSucOrderList.vue?vue&type=script&lang=js&"
export * from "./sysSucOrderList.vue?vue&type=script&lang=js&"
import style0 from "./sysSucOrderList.vue?vue&type=style&index=0&id=5e708228&prod&lang=less&scoped=true&"
import style1 from "./sysSucOrderList.vue?vue&type=style&index=1&id=5e708228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e708228",
  null
  
)

export default component.exports